<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.prescriptions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <b-container>
                        <div class="list-group list-group-flush">

                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.prescriptionDate') }}:

                                        <span class="font-weight-bold">
                                {{ date_prescription }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.drug',2) }}:

                                        <span class="font-weight-bold">
                                {{ medicaments }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <div class="card-footer text-right">
                                <b-button variant="primary" @click="updatePrescription">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </b-container>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.prescriptions', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ date_prescription }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deletePrescription">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import moment from "moment";

    export default {
        name: "Prescription",

        computed: {
            ...mapGetters(["prescription", 'hasAdminRole',
                'hasGestionnaireRole', 'hasPraticienRole',]),

            can:function(){
                if (this.hasAdminRole || this.hasGestionnaireRole ){
                    return true;
                }else if ( this.hasPraticienRole ){
                    return  this.prescription.isAuthor
                }
                return false;
            },

            mOrdonance:function(){
                return this.prescription;
            },

            date_prescription:function () {
                return moment(this.mOrdonance.date_prescription).format('DD-MM-YYYY');
            },

            medicaments:function () {
                let medoc = "";
                let self = this;
                if (!_.isUndefined(self.mOrdonance)){
                    _.forEach(self.mOrdonance.medicaments,function (medicament,key) {
                        medoc += medicament.nom_commercial + (key == (self.mOrdonance.medicaments.length -1) ? "." : ",");
                    });
                    return medoc;
                }
                return "";
            }
        },

        data(){
            return {
                prescription_id: this.$route.params.prescription,
            }
        },

        methods: {
            recupererOrdonance() {
                let args = {
                    ordonance: this.prescription_id
                };

                this.$store.dispatch("getPrescription", {args});
            },

            updatePrescription() {
                this.$router.push({ name: 'edit-prescription', params: { prescription: this.prescription_id } });
            },

            deletePrescription() {
                let self = this;
                let args = {
                    ordonance: this.prescription_id
                };

                let successMessage = this.$i18n.t('message.prescriptionDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePrescription', { args, index: self.drug_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                });
            },

            getValue(item){

                if (!_.isUndefined(this.mOrdonance)){
                    if (this.mOrdonance.hasOwnProperty(item)){
                        return this.mOrdonance[item];
                    }else{
                        return "";
                    }
                }
                return "";
            },


        },

        mounted() {
            this.recupererOrdonance();
        }

    }
</script>

<style scoped>

</style>